import { useFormik } from "formik";
import { useFileUpload, useStepData, useAddPartner } from "../hooks";
import { generateRandomUUID } from "../../../utils/helpers";
import { ErrorMessage, SuccessMessage } from "../../../utils/toastify";
import { validationSchema } from "../validations/validateForm";

const useForm = ({ onClose, onRefresh }) => {
  const fileUploadState = useFileUpload();
  const stepData = useStepData();

  const { mutate: handlePartner } = useAddPartner();

  const formik = useFormik({
    initialValues: {
      isHidden: false,
      idcarrier: "0",
      name: "",
      uiddatabase: generateRandomUUID(),
      uid_partner: "",
      step: 1,
      validEmail: false,
      isOKFileToSave: false,
      preprocess: false,
    },
    onSubmit: async (values) => {
      try {
        const res = await handlePartner({
          name: values.name,
          uiddatabase: values.uiddatabase,
          isHidden: values.isHidden,
          idcarrier: values.idcarrier,
          uid_partner: values.uid_partner,
          preprocess: values.preprocess,
        });

        if (res?.error) {
          throw new Error("Error al crear la base de datos");
        }

        _onClose();
        SuccessMessage("Registro creado exitosamente");
        onRefresh();
        return res;
      } catch (error) {
        ErrorMessage("Error al crear la base de datos");
      }
    },
    validationSchema,
  });

  const _onClose = () => {
    onClose();
    fileUploadState.reset();
    stepData.reset();
  };

  const _onReset = () => {
    formik.resetForm();
    fileUploadState.reset();
    stepData.reset();
  };

  return {
    formik,
    _onClose,
    fileUploadState,
    stepData,
    _onReset,
  };
};

export default useForm;
